import { render, staticRenderFns } from "./ycmd-facility.vue?vue&type=template&id=481156d8"
import script from "./ycmd-facility.vue?vue&type=script&lang=js"
export * from "./ycmd-facility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports